export default __webpack_public_path__ + "static/media/spark_79.367a4e0a.png";